import {
  CLIENT_ERROR,
  CONTENT_TOO_LARGE_ERROR,
  DATABASE_ERROR,
  API_ERROR,
  ASWER_ERROR,
  SERVER_ERROR,
  SERVER_TIMEOUT_ERROR,
  SESSION_ERROR,
  FORCE_ERROR,
  ENTRY_ERROR,
  LONG_RUNNING_ABORTED_ERROR,
} from '../constants';

export class ClientError extends Error {
  code?: string;

  constructor(message?: string, code?: string) {
    super(message);
    this.name = CLIENT_ERROR;
    this.code = code;
  }
}

export class DatabaseError extends Error {
  constructor(...args) {
    super(...args);
    this.name = DATABASE_ERROR;
  }
}

export class ApiError extends Error {
  constructor(...args) {
    super(...args);
    this.name = API_ERROR;
  }
}

export class AswerError extends Error {
  // Form field name to focus on submit error. Carried from the
  // response body's error.focusField through to the form submit handler.
  focusField?: string;
  constructor(message?: string, focusField?: string) {
    super(message);
    this.name = ASWER_ERROR;
    this.focusField = focusField;
  }
}

export class ContentTooLargeError extends Error {
  constructor(...args) {
    super(...args);
    this.name = CONTENT_TOO_LARGE_ERROR;
    this.message = 'Content too large';
  }
}

export class ServerError extends Error {
  constructor(...args) {
    super(...args);
    this.name = SERVER_ERROR;
  }
}

export class ServerTimeout extends Error {
  constructor(...args) {
    super(...args);
    this.name = SERVER_TIMEOUT_ERROR;
    this.message = 'Server timeout';
  }
}

export class SessionError extends Error {
  constructor(...args) {
    super(...args);
    this.name = SESSION_ERROR;
    this.message = 'Server error';
  }
}

export class ForceError extends Error {
  constructor(...args) {
    super(...args);
    this.name = FORCE_ERROR;
  }
}

export class EntryError extends Error {
  constructor(...args) {
    super(...args);
    this.name = ENTRY_ERROR;
  }
}

export class LongRunningAbortedError extends Error {
  constructor(...args) {
    super(...args);
    this.name = LONG_RUNNING_ABORTED_ERROR;
  }
}
